/** Default HTTP-retry config, composed from the retry scalars in `const/timing.ts`. Sole member and sole non-test
 * consumer: `DEFAULT_HTTP_RETRY_CONFIG` -> `utils/http/fetch-retry-loop.ts`, a GENERIC fetch retry loop. No
 * observability consumer imports this leaf, so the `observability-` topic prefix names a consumer class that does not
 * exist -- read the prefix as historical, and the retry loop above as the whole contract. */

import { API_TIMEOUTS, DEFAULT_MAX_RETRIES, GENERIC_RETRY_CONFIG } from '@federa/const/timing';
import type { HttpRetryConfig } from '@federa/types/http-api';

export const DEFAULT_HTTP_RETRY_CONFIG: HttpRetryConfig = {
	maxRetries: DEFAULT_MAX_RETRIES,
	initialDelayMs: GENERIC_RETRY_CONFIG.baseDelayMs,
	maxDelayMs: GENERIC_RETRY_CONFIG.maxDelayMs,
	backoffMultiplier: GENERIC_RETRY_CONFIG.backoffMultiplier,
	timeout: API_TIMEOUTS.longRunning,
	retryOn5xx: true,
	retryOn429: true,
	retryOnNetworkError: true,
};
